import {
  DateRange,
  defaultDateRangeFilters,
  Option,
  SplitBy,
} from "@intentsify/types";
import { isPopulatedArray } from "@intentsify/utils";
import {
  DateRangeFilter,
  Filter,
  FiltersContainer,
  FiltersContainerItem,
  FiltersContainerItemSize,
  SplitByFilter,
} from "components";
import { useParams } from "react-router-dom";
import { useAtomValue, useSetAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import {
  performingDomainsOptionsStateAtom,
  topPerformingDomainsDateRangeAtom,
  topPerformingDomainsSplitByAtom,
  topPerformingDomainsStateSelector,
  topPerformingSelectedDomainsAtom,
} from "../../TopPerformingDomains.state";

const Filters = () => {
  const campaignId = Number(useParams<"campaignId">().campaignId);
  const {
    selectedDomains,
    isLoading,
    topPerformingDomainsOptions,
    selectedSplitBy,
    selectedDateRange,
  } = useAtomValue(topPerformingDomainsStateSelector);

  const setSelectedDomains = useSetAtom(topPerformingSelectedDomainsAtom);
  const resetOptions = useResetAtom(performingDomainsOptionsStateAtom);
  const setSplitBy = useSetAtom(topPerformingDomainsSplitByAtom);
  const setDateRange = useSetAtom(topPerformingDomainsDateRangeAtom);

  const onSelectedDomainsChange = (options: Array<Option<number>>) => {
    setSelectedDomains({ campaignId, data: options });
  };

  const hasNoOptions = !isPopulatedArray(topPerformingDomainsOptions);

  const items: FiltersContainerItem[] = [
    {
      component: (
        <Filter
          label={"Accounts"}
          options={topPerformingDomainsOptions}
          isLoading={isLoading}
          isDisabled={isLoading || hasNoOptions}
          placeholder="Select accounts"
          onFilterValuesChange={(options) => {
            onSelectedDomainsChange(options);
          }}
          selected={selectedDomains.data ?? []}
        />
      ),
      size: FiltersContainerItemSize.XL,
    },
    {
      component: (
        <DateRangeFilter<DateRange>
          isLoading={isLoading}
          isDisabled={isLoading}
          dateRange={selectedDateRange}
          options={defaultDateRangeFilters.dateRangeOptions}
          onChange={(value) => {
            resetOptions();
            setDateRange(value);
          }}
        />
      ),
    },
    {
      component: (
        <SplitByFilter<SplitBy>
          onChange={(value) => setSplitBy(value)}
          options={defaultDateRangeFilters.splitByOptions}
          value={selectedSplitBy}
          isLoading={isLoading}
          isDisabled={isLoading || hasNoOptions}
        />
      ),
    },
  ];

  return <FiltersContainer items={items} />;
};

export { Filters };
